<template>
  <ul class="contents-jion">
      <h3 class="title-text">招聘精英</h3>
      <li>
          <span>{{$t("contact.tab2_address_label_1")}}</span>
          <p>18601311912</p>
      </li>
      <li>
          <span>{{$t("contact.tab2_address_label_2")}}</span>
          <p>hr@tintinhealth.com</p>
      </li>
      <li>
          <span>{{$t("contact.tab2_address_label_3")}}</span>
          <p>{{$t("contact.tab2_address_3")}}</p>
      </li>
  </ul>
</template>

<script>
    export default {
        name: '',
        data () {
            return {}
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// recruitment.vue?48f99711